import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    termsHeader: '',
    termsContent: '',
    termsSubheader: '',
};
export const termsAndConditionsSlice = createSlice({
    name: 'termsAndConditions',
    initialState,
    reducers: (create) => ({
        setTermsHeader: create.reducer((state, action) => {
            state.termsHeader = action.payload;
        }),
        setTermsContent: create.reducer((state, action) => {
            state.termsContent = action.payload;
        }),
        setTermsSubheader: create.reducer((state, action) => {
            state.termsSubheader = action.payload;
        }),
    }),
    selectors: {
        getTermsHeader: (state) => state.termsHeader,
        getTermsSubheader: (state) => state.termsSubheader,
        getTermsContent: (state) => state.termsContent,
    },
});
export const { setTermsHeader, setTermsContent, setTermsSubheader } = termsAndConditionsSlice.actions;
// export const { getTermsHeader, getTermsContent, getTermsSubheader } = termsAndConditionsSlice.selectors;
export const { getTermsHeader, getTermsContent, getTermsSubheader } = termsAndConditionsSlice.getSelectors((state) => state.termsAndConditions);
export default termsAndConditionsSlice.reducer;
